import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowBackIcon32 } from '../icons'

export interface GoBackProps {
  'data-testid': string
}

export default function GoBackButton({
  'data-testid': testId
}: Readonly<GoBackProps>) {
  const navigate = useNavigate()
  const { t } = useTranslation('common')

  const onGoBack = () => {
    navigate(-1)
  }

  return (
    <button
      type="button"
      className="text-left"
      onClick={onGoBack}
      aria-label={t('goBackButton')}
      data-testid={testId}
    >
      <ArrowBackIcon32
        className="shrink-0"
        aria-hidden="true"
        data-testid={`${testId}-icon`}
      />
    </button>
  )
}
